/// <reference path="../app.typings.d.ts" />
'use strict';
var ap;
(function (ap) {
    var Constants = /** @class */ (function () {
        function Constants() {
        }
        Object.defineProperty(Constants, "actions", {
            get: function () {
                return {
                    create: 'create',
                    edit: 'edit'
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "downloadOptions", {
            get: function () {
                return [
                    {
                        active: false,
                        extension: 'csv',
                        icon: 'file-text-o',
                        text: 'Download as CSV',
                        type: 'CSV'
                    }, {
                        active: true,
                        extension: 'xlsx',
                        icon: 'file-excel-o',
                        text: 'Download for Excel',
                        type: 'EXCELOPENXML'
                    }, {
                        active: true,
                        extension: 'pdf',
                        icon: 'file-pdf-o',
                        text: 'Download as PDF',
                        type: 'PDF'
                    }
                ];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "eventNames", {
            get: function () {
                return {
                    angular: {
                        destroy: '$destroy',
                        routeChangeStarted: '$routeChangeStart',
                        routeChangeError: '$routeChangeError',
                        routeChangeSuccess: '$routeChangeSuccess'
                    },
                    /** This is a catch all broadcast that should be replaced later with SignalR it should broadcast a IRefreshDataObject<T> - T is the type of object being updated/refreshed */
                    updatedObject: 'updatedObject'
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "key", {
            get: function () {
                return {
                    backspace: 8,
                    tab: 9,
                    enter: 13,
                    shift: 16,
                    ctrl: 17,
                    alt: 18,
                    pauseOrBreak: 19,
                    capsLock: 20,
                    escape: 27,
                    pageUp: 33,
                    pageDown: 34,
                    end: 35,
                    home: 36,
                    leftArrow: 37,
                    upArrow: 38,
                    rightArrow: 39,
                    downArrow: 40,
                    insert: 45,
                    delete: 46,
                    windowKeyLeft: 91,
                    windowKeyRight: 92,
                    selectKey: 93,
                    numpad0: 96,
                    numpad1: 97,
                    numpad2: 98,
                    numpad3: 99,
                    numpad4: 100,
                    numpad5: 101,
                    numpad6: 102,
                    numpad7: 103,
                    numpad8: 104,
                    numpad9: 105,
                    multiply: 106,
                    add: 107,
                    subtract: 109,
                    decimalPoint: 110,
                    divide: 111,
                    numLock: 144,
                    scrollLock: 145,
                    semiColon: 186,
                    equalSign: 187,
                    comma: 188,
                    dash: 189,
                    period: 190,
                    forwardSlash: 191,
                    graveAccent: 192,
                    openBracket: 219,
                    backSlash: 220,
                    closeBraket: 221,
                    singleQuote: 222
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "localStorageKeys", {
            get: function () {
                return {
                    display: {
                        /** Current Active Reports for dropdown */
                        activeReport: 'activeReports'
                    },
                    permissions: {
                        /** Application specific permissions or roles (ie. "admin", "technician", etc...) */
                        applications: 'permissionsApplications'
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "monthNames", {
            get: function () {
                return [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "productReportList", {
            get: function () {
                return [
                    {
                        label: 'All Reports',
                        disabled: false,
                        roles: [
                            AutoPointClaim.EnterpriseReports,
                            AutoPointRole.EnterpriseReportsUser,
                            AutoPointClaim.WelcomePoint,
                            AutoPointRole.WelcomePointUser,
                            AutoPointRole.DealerReportsUser,
                            AutoPointRole.UserReportsUser
                        ],
                        value: 'all'
                    },
                    {
                        label: 'Dealer Reports',
                        disabled: true,
                        roles: [AutoPointClaim.DealerReports, AutoPointRole.DealerReportsUser],
                        value: 'dealer'
                    },
                    {
                        label: 'Enterprise Group Reports',
                        disabled: true,
                        roles: [AutoPointClaim.EnterpriseReports, AutoPointRole.EnterpriseReportsUser],
                        value: 'enterprise'
                    },
                    {
                        label: 'Internal Reports',
                        disabled: true,
                        roles: [AutoPointRole.InternalReportsUser],
                        value: 'internal'
                    },
                    {
                        label: 'WelcomePoint Check-In Reports',
                        disabled: true,
                        roles: [AutoPointClaim.WelcomePoint, AutoPointRole.WelcomePointUser],
                        value: 'welcomepoint'
                    },
                    {
                        label: 'User Reports',
                        disabled: true,
                        roles: [AutoPointRole.UserReportsUser],
                        value: 'user'
                    }
                ];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "radix", {
            get: function () {
                return {
                    decimal: 10,
                    hexadecimal: 16,
                    octal: 8
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "metaValues", {
            get: function () {
                return {
                    date: {
                        custom: {
                            label: 'User Defined',
                            value: 'U'
                        }
                    },
                    multiCheckbox: {
                        all: {
                            label: 'All',
                            value: '-1'
                        }
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "reportsList", {
            get: function () {
                return [
                    {
                        active: true,
                        associatedProduct: 'welcomepoint',
                        productId: AutoPointRole.WelcomePointUser,
                        id: 1,
                        name: 'Process Metrics',
                        desc: 'Track how well advisors are following your prescribed processes during the service write-up.',
                        systemName: 'reportingProcessMetrics',
                        image: 'images/process-metrics.png'
                    }, {
                        active: true,
                        associatedProduct: 'welcomepoint',
                        productId: AutoPointRole.WelcomePointUser,
                        id: 2,
                        name: 'Sales Performance',
                        desc: 'Review write-up sales from deferred recommendations, walk-around inspections, service campaigns, scheduled maintenance, service menus, and tires by advisor.',
                        systemName: 'reportingSalesPerformance',
                        image: 'images/sales-performance.png'
                    }, {
                        active: true,
                        associatedProduct: 'welcomepoint',
                        productId: AutoPointRole.WelcomePointUser,
                        id: 3,
                        name: 'Performance Averages',
                        desc: 'View the average sale per write-up from deferred recommendations, walk-around inspections, service campaigns, scheduled maintenance, service menus, and tires by advisor.',
                        systemName: 'reportingPerformanceAverages',
                        image: 'images/performance-averages.png'
                    }, {
                        active: true,
                        associatedProduct: 'welcomepoint',
                        productId: AutoPointRole.WelcomePointUser,
                        id: 4,
                        name: 'Shop Benchmarks',
                        desc: 'Review average sales amount for deferred recommendations, walk-around inspections, service campaigns, scheduled maintenance, service menus, and tires by advisor.',
                        systemName: 'reportingShopBenchmarks',
                        image: 'images/shop-benchmarks.png'
                    }
                ];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "routes", {
            get: function () {
                return {
                    dashboard: {
                        controller: app.Dashboard.DashboardController,
                        controllerAs: 'ctrl',
                        label: 'Dashboard',
                        name: 'dashboard',
                        templateUrl: 'app/dashboard/index.html',
                        reportPath: '',
                        route: 'dashboard'
                    },
                    reporting: {
                        controller: app.Reporting.ReportingController,
                        controllerAs: 'ctrl',
                        label: 'Reports',
                        name: 'reporting',
                        templateUrl: 'app/reporting/index.html',
                        reportPath: '',
                        route: 'reports/:organizationCacheKey?'
                    },
                    reportDisplay: {
                        controller: app.Reporting.ReportDisplayController,
                        controllerAs: 'ctrl',
                        templateUrl: 'app/reporting/report-display/index.html',
                        reportPath: '',
                        route: 'reports/display'
                    },
                    reportingProcessMetrics: {
                        controller: app.Reporting.ReportDisplayController,
                        controllerAs: 'ctrl',
                        label: 'Process Metrics',
                        name: 'process-metrics',
                        templateUrl: 'app/reporting/report-display/index.html',
                        reportPath: '',
                        route: 'process-metrics'
                    },
                    reportingSalesPerformance: {
                        controller: app.Reporting.ReportDisplayController,
                        controllerAs: 'ctrl',
                        label: 'Sales Performance',
                        name: 'sales-performance',
                        templateUrl: 'app/reporting/report-display/index.html',
                        reportPath: '',
                        route: 'sales-performance'
                    },
                    reportingPerformanceAverages: {
                        controller: app.Reporting.ReportDisplayController,
                        controllerAs: 'ctrl',
                        label: 'Performances Averages',
                        name: 'performance-averages',
                        templateUrl: 'app/reporting/report-display/index.html',
                        reportPath: '',
                        route: 'performance-averages'
                    },
                    reportingShopBenchmarks: {
                        controller: app.Reporting.ReportDisplayController,
                        controllerAs: 'ctrl',
                        label: 'Shop Benchmarks',
                        name: 'shop-benchmarks',
                        templateUrl: 'app/reporting/report-display/index.html',
                        reportPath: '',
                        route: 'shop-benchmarks'
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "enterpriseReports", {
            get: function () {
                return {
                    defaultValues: {
                        dateRangeShort: 'MTD',
                        dateRangeLabelShort: 'Month to Date',
                        dateRangeLong: 'Current Month -0',
                        dateRangeLabelLong: 'Current Month',
                        payType: [1],
                        payTypeValues: {
                            all: false,
                            customerpay: true,
                            warranty: false,
                            internal: false
                        },
                        dealerCacheKey: Guid.empty,
                        dealerName: 'All'
                    },
                    ssrsKeys: {
                        payTypes: [
                            {
                                id: 'all',
                                name: 'All',
                                value: -1
                            },
                            {
                                id: 'customerpay',
                                name: 'Customer Pay',
                                value: 1
                            },
                            {
                                id: 'warranty',
                                name: 'Warranty',
                                value: 2
                            },
                            {
                                id: 'internal',
                                name: 'Internal',
                                value: 3
                            }
                        ],
                        taskStatus: [
                            {
                                name: 'All',
                                value: -1
                            },
                            {
                                name: 'Caution',
                                value: 2
                            },
                            {
                                name: 'Fail',
                                value: 3
                            }
                        ],
                        variableDateRange: [
                            {
                                name: 'Last 3 Days',
                                value: '3'
                            },
                            {
                                name: 'Last 7 Days',
                                value: '7'
                            },
                            {
                                name: 'Last 30 Days',
                                value: '30'
                            },
                            {
                                name: 'Last 60 Days',
                                value: '60'
                            },
                            {
                                name: 'Last 90 Days',
                                value: '90'
                            },
                            {
                                name: 'Last 120 Days',
                                value: '120'
                            },
                            {
                                name: 'Last 180 Days',
                                value: '180'
                            },
                            {
                                name: 'This Month',
                                value: 'TM'
                            },
                            {
                                name: 'Week to Date',
                                value: 'WTD'
                            },
                            {
                                name: 'Month to Date',
                                value: 'MTD'
                            },
                            {
                                name: 'Year to Date',
                                value: 'YTD'
                            },
                            {
                                name: 'Today',
                                value: 'T'
                            },
                            {
                                name: 'Yesterday',
                                value: 'Y'
                            },
                            {
                                name: 'Last Week',
                                value: 'LW'
                            },
                            {
                                name: 'Last Month',
                                value: 'LM'
                            },
                            {
                                name: 'Last Month/Month to Day After 1st',
                                value: 'LMMTD'
                            },
                            {
                                name: 'Last Year',
                                value: 'LY'
                            },
                            {
                                name: 'Last 12 Months',
                                value: 'L12M'
                            },
                            {
                                name: 'Last 13 Months',
                                value: 'L13M'
                            },
                            {
                                name: 'User Defined',
                                value: 'U'
                            }
                        ]
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "timeStampKey", {
            get: function () {
                return 'vTaSDHWefh';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "translationKeys", {
            get: function () {
                return {
                    directives: {
                        loading: 'DIRECTIVES.LOADING'
                    },
                    errorMessages: {
                        internalServerError: 'ERROR_MESSAGES.INTERNAL_SERVER_ERROR'
                    },
                    general: {},
                    modals: {
                        cancelButtons: {
                            cancel: 'MODALS.CANCEL_BUTTONS.CANCEL',
                            close: 'MODALS.CANCEL_BUTTONS.CLOSE',
                            no: 'MODALS.CANCEL_BUTTONS.NO'
                        },
                        saveButtons: {
                            ok: 'MODALS.SAVE_BUTTONS.OK',
                            save: 'MODALS.SAVE_BUTTONS.SAVE',
                            yes: 'MODALS.SAVE_BUTTONS.YES'
                        },
                        saving: 'MODALS.SAVING'
                    },
                    shell: {
                        login: 'SHELL.LOGIN',
                        logo: 'SHELL.AUTOPOINT_LOGO',
                        logout: 'SHELL.LOGOUT',
                        greeting: 'SHELL.GREETING',
                        selectLang: 'SHELL.SELECT_LANG',
                        selectLocation: 'SHELL.SELECT_LOCATION'
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "updatedObjects", {
            get: function () {
                return {
                    package: 'package',
                    section: 'section',
                    task: 'task'
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "wpReportsList", {
            get: function () {
                return [
                    {
                        active: true,
                        productId: AutoPointRole.WelcomePointUser,
                        id: 1,
                        name: 'Process Metrics',
                        description: 'Track how well advisors are following your prescribed processes during the service write-up.',
                        systemName: 'reportingProcessMetrics',
                        image: 'images/process-metrics.png',
                        iconMediaId: '83408ACE-B16D-438E-A782-476178E6D1EC',
                        uiReportName: 'Process Metrics',
                        behaviorRules: undefined,
                        createdAt: '2015-08-13 10:00:00.0000000 -07:00',
                        createdBy: 'John Smith',
                        displayOrder: -4,
                        isActive: true,
                        isDealerLevel: false,
                        isGroupLevel: false,
                        isInternalLevel: false,
                        isUsedbyAllOrgs: false,
                        isUserLevel: false,
                        isWpReport: true,
                        parameters: [],
                        ssrsName: 'process-metrics',
                        ssrsPath: 'process-metrics',
                        updatedAt: '2015-08-13 10:00:00.0000000 -07:00'
                    }, {
                        active: true,
                        behaviorRules: undefined,
                        productId: AutoPointRole.WelcomePointUser,
                        id: 2,
                        name: 'Sales Performance',
                        description: 'Review write-up sales from deferred recommendations, walk-around inspections, service campaigns, scheduled maintenance, service menus, and tires by advisor.',
                        systemName: 'reportingSalesPerformance',
                        image: 'images/sales-performance.png',
                        iconMediaId: '6B168994-68BD-4BF6-A4D5-A7D11057258C',
                        uiReportName: 'Sales Performance',
                        createdAt: '2015-08-13 10:00:00.0000000 -07:00',
                        createdBy: 'John Smith',
                        displayOrder: -3,
                        isActive: true,
                        isDealerLevel: false,
                        isGroupLevel: false,
                        isInternalLevel: false,
                        isUsedbyAllOrgs: false,
                        isUserLevel: false,
                        isWpReport: true,
                        parameters: [],
                        ssrsName: 'sales-performance',
                        ssrsPath: 'sales-performance',
                        updatedAt: '2015-08-13 10:00:00.0000000 -07:00'
                    }, {
                        active: true,
                        productId: AutoPointRole.WelcomePointUser,
                        id: 3,
                        name: 'Performance Averages',
                        description: 'View the average sale per write-up from deferred recommendations, walk-around inspections, service campaigns, scheduled maintenance, service menus, and tires by advisor.',
                        systemName: 'reportingPerformanceAverages',
                        image: 'images/performance-averages.png',
                        iconMediaId: '96533A85-4CF9-4B98-B9CF-6E560BD84A7B',
                        uiReportName: 'Performance Averages',
                        behaviorRules: undefined,
                        createdAt: '2015-08-13 10:00:00.0000000 -07:00',
                        createdBy: 'John Smith',
                        displayOrder: -2,
                        isActive: true,
                        isDealerLevel: false,
                        isGroupLevel: false,
                        isInternalLevel: false,
                        isUsedbyAllOrgs: false,
                        isUserLevel: false,
                        isWpReport: true,
                        parameters: [],
                        ssrsName: 'performance-averages',
                        ssrsPath: 'performance-averages',
                        updatedAt: '2015-08-13 10:00:00.0000000 -07:00'
                    }, {
                        active: true,
                        productId: AutoPointRole.WelcomePointUser,
                        id: 4,
                        name: 'Shop Benchmarks',
                        description: 'Review average sales amount for deferred recommendations, walk-around inspections, service campaigns, scheduled maintenance, service menus, and tires by advisor.',
                        systemName: 'reportingShopBenchmarks',
                        image: 'images/shop-benchmarks.png',
                        iconMediaId: '83408ACE-B16D-438E-A782-476178E6D1EC',
                        uiReportName: 'Shop Benchmarks',
                        behaviorRules: undefined,
                        createdAt: '2015-08-13 10:00:00.0000000 -07:00',
                        createdBy: 'John Smith',
                        displayOrder: -1,
                        isActive: true,
                        isDealerLevel: false,
                        isGroupLevel: false,
                        isInternalLevel: false,
                        isUsedbyAllOrgs: false,
                        isUserLevel: false,
                        isWpReport: true,
                        parameters: [],
                        ssrsName: 'shop-benchmarks',
                        ssrsPath: 'shop-benchmarks',
                        updatedAt: '2015-08-13 10:00:00.0000000 -07:00'
                    }
                ];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "writeUpTypes", {
            get: function () {
                return [
                    { id: 0, value: 'All Types' },
                    { id: 1, value: 'Appointments' },
                    { id: 2, value: 'Walk-Ins' }
                ];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Constants, "redcapReportTitles", {
            get: function () {
                return [
                    'process-metrics',
                    'sales-performance',
                    'performance-averages',
                    'shop-benchmarks'
                ];
            },
            enumerable: true,
            configurable: true
        });
        return Constants;
    }());
    ap.Constants = Constants;
})(ap || (ap = {}));
